<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Presupuestos" resource="proyectos" primaryKey="idpresupuesto" :records="records" :meta="meta"
        :columns="columns" :readonly="readonly">
        <template v-slot:actions v-if="isAdmin">
          <button
            class="bg-yellow-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button" @click="descargarReporte()">
            {{ $t('Descargar reporte') }}
          </button>
        </template>
        <template v-slot:after-table>
          <totales-proyectos :meta="meta" />
        </template>
      </card-list>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { useToast } from "vue-toastification";
import CardList from "@/components/Cards/CardList.vue";
import TotalesProyectos from "@/components/Cards/TotalesProyectos.vue";
import PresupuestoService from "@/services/presupuesto.service";
import ReporteService from "@/services/reporte.service";
import { presupuesto } from "@/models/presupuesto";
import { hasActiveFilters } from "@/utils/filterUtils";
import { descargarCSV } from "@/utils/descargas";

export default {
  components: {
    CardList,
    TotalesProyectos,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: presupuesto.filter(column => column.showOnList),
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        PresupuestoService.list({ ...this.$route.query })
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.user,
    }),

    readonly() {
      const roles = this.userInfo?.roles || [];
      return !roles.includes('admin') && !roles.includes('personal');
    },

    // El CSV trae costos y montos, así que /reportes/proyectosCSV es admin.
    // Sin este chequeo el rol personal (que no es readonly) veía el botón y
    // recibía un 403 al usarlo.
    isAdmin() {
      return this.userInfo?.roles?.includes('admin');
    },
  },

  methods: {
    descargarReporte() {
      if (
        hasActiveFilters(this.$route.query) &&
        !confirm(this.$t("confirm.exportSelection"))
      ) {
        return;
      }

      const toast = useToast();

      ReporteService.proyectosCSV({ filters: this.$route.query.filters })
        .then((response) => {
          descargarCSV(response, 'proyectos.csv');
          toast.success("CSV exportado exitosamente");
        })
        .catch((error) => {
          toast.error("Error al exportar CSV");
          console.error(error);
        });
    }
  }
};
</script>
